import { Languages } from "lucide-react";
import { useLanguage } from "../lib/language";

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage();
  const enableEnglish =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    new URLSearchParams(window.location.search).get("enableEnglish") === "1";

  return (
    <div className="inline-flex h-10 items-center rounded-lg border border-line bg-white p-1 text-xs font-bold text-slate-600">
      <Languages size={15} className="ml-2 mr-1 text-muted" aria-hidden="true" />
      <button
        className={`h-8 rounded-md px-2 transition ${language === "vi" ? "bg-blue-50 text-brand" : "hover:bg-slate-50"}`}
        type="button"
        aria-pressed={language === "vi"}
        onClick={() => setLanguage("vi")}
      >
        Việt
      </button>
      {enableEnglish ? (
      <button
        className={`h-8 rounded-md px-2 transition ${language === "en" ? "bg-blue-50 text-brand" : "hover:bg-slate-50"}`}
        type="button"
        aria-pressed={language === "en"}
        onClick={() => setLanguage("en")}
        title="English mode is still in preview"
      >
        EN
      </button>
      ) : null}
    </div>
  );
}
